<template>
    <div class="aff-container">
        <!-- <v-row class="m-0">
            <div class="aff-num-player">
                <h6 class="aff-num-player-label mb-0">{{ $t('title.number_of_player') }}</h6>
                <p class="aff-num-player-value">{{ getCountPlayer }}</p>
            </div>
            <v-spacer></v-spacer>
            <InviteLink />
        </v-row>
        <v-row class="mx-0 aff-top-spacer">
            <AffReport />
            <v-spacer></v-spacer>
            <div class="aff-chart-container">
                <v-card>
                    <BarChart />
                </v-card>
            </div>
        </v-row> -->
        <v-row class="m-0">
            <v-col cols="12" sm="12">
                <AffReport style="margin-left: 8px;"/>
            </v-col>
        </v-row>
        <v-row class="m-0">
            <v-col cols="12" sm="6">
                <v-card class="aff-num-player">
                    <h6 class="aff-num-player-label mb-0">{{ $t('title.number_of_player') }}</h6>
                    <p class="aff-num-player-value">{{ getCountPlayer }}</p>
                </v-card>
            </v-col>
            <v-col cols="12" sm="6">
                <InviteLink style="margin-top: 8px;"/>
            </v-col>
        </v-row>
        <!-- aff-top-spacer -->
        <v-row class="m-0">
            <v-col cols="12" sm="12">
                <!-- <v-card class="aff-num-player">
                    <h6 class="aff-num-player-label mb-0">{{ $t('title.number_of_player') }}</h6>
                    <p class="aff-num-player-value">{{ getCountPlayer }}</p>
                </v-card>
                <InviteLink style="margin-top: 8px;"/> -->
                <div class="aff-chart-container"  style="margin-top: 8px;">
                    <v-card>
                        <BarChart />
                    </v-card>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import "@/assets/css/affiliate_dashboard/affiliate_share_style.css";
import "@/assets/css/affiliate_dashboard/screen_max_480.css";
import "@/assets/css/affiliate_dashboard/screen_min_481.css";
import "@/assets/css/affiliate_dashboard/screen_min_768.css";
import "@/assets/css/affiliate_dashboard/screen_min_993.css";
import "@/assets/css/affiliate_dashboard/screen_min_1025.css";
import "@/assets/css/affiliate_dashboard/screen_min_1281.css";
import "@/assets/css/affiliate_dashboard/screen_min_1440.css";
import "@/assets/css/affiliate_dashboard/screen_min_1660.css";
import "@/assets/css/affiliate_dashboard/screen_min_1824.css";
import BarChart from './components/BarChart.vue';
import InviteLink from './components/InviteLink.vue';
import AffReport from './components/AffReport.vue';
import moment from "moment";
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
    name: 'App',
    components: {
        BarChart,
        InviteLink,
        AffReport
    },
    computed: {
        ...mapGetters("$_affiliate",
            {
                getCountPlayer: "getCountPlayer",
                getSelectedDefaultMonth: 'getSelectedDefaultMonth'
            })
    },
    async created() {
        await this.fetchCountPlayerOfAffiliate();
        const selectDate = {
            month: moment().format('M'),
            year: moment().format('YYYY')
        }
        await this.fetchAffReport(selectDate);

    },

    methods: {
        moment,
        async callReportAff() {
            await this.fetchAffReport(this.selectMonth);
        },
        ...mapActions("$_affiliate", [
            "fetchCountPlayerOfAffiliate",
            "fetchAffReport",
            "fetchBarChart"
        ]),
        ...mapMutations("$_affiliate", [
            "CLEAR_BAR_CHART_PROGRESS",
        ]),

    },
    beforeRouteLeave(to, from, next) {
        this.CLEAR_BAR_CHART_PROGRESS()
        next();
    },
}
</script>
<style></style>